import { allOf, check, type PermissionResult } from '@/components/common/permission'

export function lineItemSidesheetPermission(
  assignedProviderId: string | null | undefined,
  organizationId: string | null | undefined,
  isApproved = false,
): PermissionResult {
  return allOf(
    check(
      !!assignedProviderId && assignedProviderId === organizationId,
      'Your organization is not the assigned service provider.',
    ),
    check(!isApproved, 'This job has been approved.'),
  )
}

export function lineItemActionPermission({
  editPermission,
  readonly,
  approvalRestricted,
  hasApprovalAccess,
  isLoading,
  isError,
  errorStatus,
}: {
  editPermission?: PermissionResult
  readonly: boolean
  approvalRestricted: boolean
  hasApprovalAccess: boolean
  isLoading: boolean
  isError: boolean
  errorStatus?: number
}): PermissionResult {
  return allOf(
    editPermission ?? check(!readonly, 'Line items are read-only in this view.'),
    check(
      !isError,
      errorStatus === 403
        ? 'You do not have permission to view line items.'
        : 'Line items could not be loaded.',
    ),
    approvalRestricted
      ? check(
          hasApprovalAccess,
          'A dispatcher or admin role is required for pending or approved jobs.',
        )
      : check(!isLoading, 'Line items are loading.'),
  )
}
